import { render, staticRenderFns } from "./ProductFormVariantOrigin.vue?vue&type=template&id=ac57f496&"
import script from "./ProductFormVariantOrigin.vue?vue&type=script&lang=js&"
export * from "./ProductFormVariantOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports